import store from '@/store'

export default function useSkutopia() {
    
    const fetchSecureMediaBlob = async (mediaUrl) => {
        try {
            
            return store
              .dispatch('app-skutopia/fetchSecureMediaBlob', mediaUrl)
              .then(response => {
                const blob = response.data || response 
                // Create a local blob URL
                return URL.createObjectURL(blob)
    
            })
            .catch(error => {
                // store.commit('app/LOADING', false)
                console.log(error.response)
            })
            
            
        } catch (error) {
            console.error("Failed to fetch secure media blob:", error)
            return null
        } finally{

        }
    }

    return {
        fetchSecureMediaBlob
    }
}